import styled from 'styled-components';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FilterSectionsWrapper = styled(FlexRow)`
  justify-content: flex-start;
`;

export const PopoverFooterWrapper = styled(FlexRow)`
  padding-top: 10px;
  border-top: solid 1px #c7c7c7;
  justify-content: space-between;
`;

export const ColumnWrapper = styled.div`
  width: ${(props) => `${props.width}px`};
`;

export const PopoverContentWrapper = styled.div`
  padding: 16px 20px 12px 22px;
  width: 605px;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  max-height: calc(100vh - 230px);
`;

// Removes the box arrow
export const PopoverWrapper = styled.div`
  .rs-popover > .rs-popover-arrow:after {
    content: unset;
  }
`;

export const ClearFilterButton = styled.button`
  background-color: white;
  :active {
    transform: scale(0.95);
  }

  :focus {
    outline: 0;
  }
`;

export const FilterTextWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  text-decoration: underline;
  height: 14px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.5);
`;
